import Pusher from "pusher-js";
import {PUSHER_KEY, AGENT_PUSHER_KEY, AGENT_PUSHER_CLUSTER} from "../settings/local_settings";

Pusher.logToConsole = false;

export const WebSocketChannels = {
    BU_DASHBOARD_SYNC: 'bu-dashboard-sync',
    URL_STATUS_CHANGE: 'bu-urls-status-sync'
};

export const WebSocketEvents = {
    BU_DASHBOARD_SYNCED: 'bu-dashboard-synced',
    URL_STATUS_CHANGE: 'bu-urls-status-synced'
};

const pusherClient = new Pusher(PUSHER_KEY, {
    cluster: 'us2',
    forceTLS: true
});

export const WebSocketsClient = {
    subscribe: (channelName) => {
        const channel = pusherClient.subscribe(channelName);
        return channel;
    }
};

// Cliente Pusher separado para eventos de progreso del agente
const agentPusherClient = AGENT_PUSHER_KEY ? new Pusher(AGENT_PUSHER_KEY, {
    cluster: AGENT_PUSHER_CLUSTER,
    forceTLS: true
}) : null;

if (agentPusherClient) {
    agentPusherClient.connection.bind('connected', () => {
        console.log('[AgentPusher] Connected, socketId:', agentPusherClient.connection.socket_id);
    });
    agentPusherClient.connection.bind('error', (err) => {
        console.error('[AgentPusher] Connection error:', err);
    });
    agentPusherClient.connection.bind('state_change', (states) => {
        console.log('[AgentPusher] State:', states.previous, '->', states.current);
    });
}

export const AgentWebSocketsClient = {
    subscribe: (channelName) => {
        if (!agentPusherClient) return null;
        return agentPusherClient.subscribe(channelName);
    },
    unsubscribe: (channelName) => {
        if (agentPusherClient) agentPusherClient.unsubscribe(channelName);
    }
};